import { Checkbox, Space } from "antd";
import CardPartial from "../partials/Card";
import InputHolder from "../partials/Input";
import DateInputHolder from "../partials/DateInput";
import { UserFormInterface } from "../definitions";
import dayjs from "dayjs";

interface Step2Props {
  userForm: UserFormInterface;
  errors: { [key: string]: string };
  fillableForm: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBirthDateChange: (date: dayjs.Dayjs | null, dateString: string) => void;
  onBirthDateChange2: (date: dayjs.Dayjs | null, dateString: string) => void;
  onTwinBirthdayChange: (checked: boolean) => void;
  onTwoChildrenBirthdayChange: (checked: boolean) => void;
  activeTime: string | null;
  isPosting: boolean;
  guestOverflow: number;
}

const Step2: React.FC<Step2Props> = ({
  userForm,
  errors,
  fillableForm,
  onBirthDateChange,
  onBirthDateChange2,
  onTwinBirthdayChange,
  onTwoChildrenBirthdayChange,
  activeTime,
  isPosting,
  guestOverflow,
}) => {
  return (
    <CardPartial
      isPosting={isPosting}
      title="Kontaktinė informacija"
      active_time={activeTime}
    >
      <Space className="w-full" direction="vertical" wrap>
        {/* Dvynių / dviejų vaikų gimtadienis */}
        <Checkbox
          checked={userForm.is_two_children_birthday}
          onChange={(e) => onTwoChildrenBirthdayChange(e.target.checked)}
          disabled={isPosting || userForm.is_twin_birthday}
        >
          Pažymėkite, jei švęsite dviejų vaikų gimtadienius vienu metu
        </Checkbox>
        <Checkbox
          checked={userForm.is_twin_birthday}
          onChange={(e) => onTwinBirthdayChange(e.target.checked)}
          disabled={isPosting || userForm.is_two_children_birthday}
        >
          Pažymėkite, jei švęsite dvynukų gimtadienį
        </Checkbox>

        <InputHolder
          userForm={userForm}
          errors={errors}
          fillableForm={fillableForm}
          name="customer_name"
          placeholder={userForm.is_twin_birthday ? "Abiejų vaikų vardai (pvz. Rusnė ir Tomas)" : userForm.is_two_children_birthday ? "Jaunesnio vaiko vardas" : "Vaiko vardas"}
          displayName={userForm.is_twin_birthday ? "Įrašykite dvynių vardus, pvz.: Rusnė ir Tomas" : userForm.is_two_children_birthday ? "Jaunesnio vaiko vardas" : undefined}
          autoComplete="given-name"
        />
        {!userForm.is_two_children_birthday && (
          <small style={{ fontSize: "10px" }}>
            Vaiko vardas naudojamas kvietime, patikrinkite ar be klaidų parašėte vaiko vardą!
          </small>
        )}
        <DateInputHolder
          userForm={userForm}
          errors={errors}
          onChange={onBirthDateChange}
          name="child_birth_date"
          placeholder={userForm.is_two_children_birthday ? "Jaunesnio vaiko gimimo data pvz. 2015-09-01" : "Pasirinkite gimimo datą pvz. 2015-09-01"}
          displayName={userForm.is_two_children_birthday ? "Jaunesnio vaiko gimimo data" : "Vaiko gimimo data"}
        />
        {userForm.customer_age > 0 && !userForm.is_two_children_birthday && (
          <div
            style={{
              textAlign: "center",
              color: "#1890ff",
              fontWeight: "bold",
              fontSize: "16px",
              marginTop: "8px",
            }}
          >
            Bus švenčiamas {userForm.customer_age}-asis gimtadienis! 🎉
          </div>
        )}

        {/* Vyresnio vaiko informacija (tik dviejų vaikų gimtadieniui) */}
        {userForm.is_two_children_birthday && (
          <>
            <InputHolder
              userForm={userForm}
              errors={errors}
              fillableForm={fillableForm}
              name="child_name_2"
              placeholder="Vyresnio vaiko vardas"
              displayName="Vyresnio vaiko vardas"
              autoComplete="off"
            />
            <DateInputHolder
              userForm={userForm}
              errors={errors}
              onChange={onBirthDateChange2}
              name="child_birth_date_2"
              placeholder="Vyresnio vaiko gimimo data pvz. 2013-06-08"
              displayName="Vyresnio vaiko gimimo data"
            />
          </>
        )}

        <InputHolder
          userForm={userForm}
          errors={errors}
          fillableForm={fillableForm}
          name="customer_guests"
          placeholder="Pvz. 10"
          autoComplete="off"
          type="number"
          min={1}
          max={24}
          displayName="Planuojamas vaikų skaičius"
        />
        <div
          className={`text-red-400 text-xs text-center ${
            userForm.customer_guests > guestOverflow ? "block" : "hidden"
          }`}
        >
          Jei gimtadienyje dalyvauja daugiau nei {guestOverflow} vaikų, tuomet
          už kiekvieną papildomą vaiką taikomas 5.00 EUR mokestis.
        </div>
        <InputHolder
          userForm={userForm}
          errors={errors}
          fillableForm={fillableForm}
          name="customer_parent_name"
          placeholder="Vieno iš tėvų vardas ir pavardė"
          autoComplete="name"
        />
        <InputHolder
          userForm={userForm}
          errors={errors}
          fillableForm={fillableForm}
          name="customer_address"
          placeholder="Gyvenamosios vietos adresas"
          autoComplete="street-address"
        />
        <InputHolder
          displayName="Telefono numeris"
          userForm={userForm}
          errors={errors}
          fillableForm={fillableForm}
          name="customer_phone_no"
          prefix="+370"
          placeholder="6000000"
          autoComplete="tel-national"
        />
        <InputHolder
          userForm={userForm}
          errors={errors}
          fillableForm={fillableForm}
          name="customer_email"
          placeholder="El. paštas"
          autoComplete="email"
          type="email"
        />
      </Space>
    </CardPartial>
  );
};

export default Step2;
